import Vue from 'vue'
import VueRouter from 'vue-router'
import HomeView from '../views/HomeView.vue'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'home',
    component: HomeView
  },
  {
    path: '/alcohol',
    name: 'alcohol',
    component: function () {
      return import(/* webpackChunkName: "alcohol" */ '../views/AlcoholView.vue')
    }
  },
  {
    path: '/vaping',
    name: 'vaping',
    component: function () {
      return import(/* webpackChunkName: "vaping" */ '../views/NicotineView.vue')
    }
  },
  {
    path: '/cannabis',
    name: 'cannabis',
    component: function () {
      return import(/* webpackChunkName: "cannabis" */ '../views/CannabisView.vue')
    }
  },
  {
    path: '/accessiblity',
    name: 'accessiblity',
    component: function () {
      return import(/* webpackChunkName: "accessiblity" */ '../views/AccessibilityView.vue')
    }
  }
]

const router = new VueRouter({
  mode: 'history',
  base: '/javascript-activities/pressure-points/',
  // base: '/proof/pp-test/',
  // base: '/',
  routes
})

export default router
